storefrontApp.controller("currencyConverterController", [
    "$document", "$rootScope", "$scope", "$timeout", "$window", "commonService", 'storageFactory', "configs",
    function (
        $document, $rootScope, $scope, $timeout, $window, commonService, storageFactory, configs
    ) {
        // Initialize variables
        var autoCurrencyConversionCookieName = configs && configs.autoCurrencyConversionCookieName;
        var autoCurrencyConversionIterations = 0;
        var autoCurrencyConversionTimer = 500;

        $rootScope.currencyConversion = {
            displayCurrency: null,
            excludedUrls: (configs && configs.currencyConverterExcludedUrls) || [],
            localCurrency: null,
            redirectUrl: null,
            showModal: false,
            storeCurrency: null,
        };

        // Event handling
        $rootScope.$on("RefreshCurrencyConversion", function (_event, timeout) {
            refreshCurrencyConversion(timeout);
        });

        // Currency Conversion Functions
        $scope.currencyConverterExitConfirmed = function () {
            $rootScope.appModalOpen = false;
            $rootScope.currencyConversion.showModal = false;
            $window.location.href = $rootScope.currencyConversion.redirectUrl;
        };

        $scope.toggleCurrency = function () {
            var targetCurrency =
                $rootScope.currencyConversion.displayCurrency ==
                    $rootScope.currencyConversion.storeCurrency
                    ? $rootScope.currencyConversion.localCurrency
                    : $rootScope.currencyConversion.storeCurrency;

            convertCurrencies(
                $rootScope.currencyConversion.displayCurrency,
                targetCurrency
            );

            $rootScope.currencyConversion.displayCurrency = targetCurrency;
            commonService.setCookie(
                autoCurrencyConversionCookieName,
                $rootScope.currencyConversion.displayCurrency ==
                $rootScope.currencyConversion.localCurrency,
                365
            );
        };

        // Private Functions
        function checkAutoCurrencyConversion() {
            $rootScope.currencyConversion.localCurrency &&
                commonService.getCookie(autoCurrencyConversionCookieName) == "true" &&
                $timeout(function () {
                    if (autoCurrencyConversionIterations == 0)
                        $scope.toggleCurrency();
                    else refreshCurrencyConversion();

                    autoCurrencyConversionTimer = autoCurrencyConversionTimer * 2;
                    autoCurrencyConversionIterations++;

                    if (autoCurrencyConversionIterations <= 3)
                        checkAutoCurrencyConversion();
                }, autoCurrencyConversionTimer);
        }

        function convertCurrencies(sourceCurrency, targetCurrency) {
            // Conversion logic
            sourceCurrency.symbol.match(
                new RegExp("^[" + targetCurrency.regexSymbol + "]+$")
            ) && convertCurrencies(targetCurrency, sourceCurrency);

            // Update the content in the DOM
            commonService
                .getHTMLTextNodes($document[0].body)
                .forEach(function (node) {
                    node.data = node.data.replace(
                        new RegExp(
                            "(" +
                            sourceCurrency.regexSymbol +
                            ")([0-9]*)((\\,[0-9]*)?)*(\\.[0-9][0-9])+",
                            "g"
                        ),
                        function (money) {
                            var oldPrice = parseFloat(
                                money.substring(Number(sourceCurrency.symbol.length)).replace(/,/g, "")
                            );
                            return (
                                targetCurrency.symbol +
                                commonService.formatMoney(
                                    targetCurrency ==
                                        $rootScope.currencyConversion.localCurrency
                                        ? oldPrice * $rootScope.currencyConversion.localCurrency.exchangeRate
                                        : oldPrice / $rootScope.currencyConversion.localCurrency.exchangeRate,
                                    2, ".", ","
                                )
                            );
                        }
                    );
                });
        }

        // Initialize currency conversion
        function getContent(value) {
            if (angular.isUndefined(value) || value === null) {
                return null;
            }
            var storedValues = value.split("expiry:");
            if (commonService.checkAdExpiry(storedValues[1])) {
                return storedValues[0];
            }
            return null;
        }

        function initializeCurrencyConversion() {
            var storedCurrencyData = getContent(storageFactory.get("storeLocalCurrency"));
            if (storedCurrencyData == null || window.resetAdsCacheState) {
                commonService.getStoreAndLocalCurrency().then(function (response) {
                    if(response && response.data){
                        storageFactory.set("storeLocalCurrency", JSON.stringify(response.data), true);
                    }
                    configureCurrencyConversion(response.data);
                });
            }
            else {
                var parsedStored = null;
                try {
                    parsedStored = JSON.parse(storedCurrencyData);
                } catch (e) {
                    parsedStored = null;
                }
                if (parsedStored && angular.isDefined(parsedStored.countryCode)) {
                    configureCurrencyConversion(parsedStored);
                } else {
                    commonService.getStoreAndLocalCurrency().then(function (response) {
                        if(response && response.data){
                            storageFactory.set("storeLocalCurrency", JSON.stringify(response.data), true);
                        }
                        configureCurrencyConversion(response.data);
                    });
                }
            }
        }

        function configureCurrencyConversion(data) {
            var cc = (data && data.countryCode) || "";
            window.__storefrontCountryCode = cc;
            $rootScope.$emit("CountryCodeCookieSet", cc);
            document.dispatchEvent(
                new CustomEvent("CountryCodeCookieSet", {
                    detail: { countryCode: cc },
                })
            );
            if (
                (cc || "").toUpperCase() != "US" &&
                !_.some(
                    $rootScope.currencyConversion.excludedUrls,
                    function (url) {
                        if (url.indexOf("*") > -1) {
                            var urlArray = _.compact(url.split("/"));
                            var pathArray = _.compact(
                                $window.location.pathname.split("/")
                            );
                            return (
                                urlArray.length == pathArray.length &&
                                _.every(urlArray, function (x, i) {
                                    return (
                                        x == "*" || x.toLowerCase() == pathArray[i].toLowerCase()
                                    );
                                })
                            );
                        } else{
                            return (
                                $window.location.pathname.toLowerCase() == url.toLowerCase() ||
                                $window.location.pathname.toLowerCase() == url.toLowerCase() + "/"
                            );
                        }
                    }
                )
            ) {
                if(angular.isDefined(data)){
                    $rootScope.currencyConversion.displayCurrency = data.storeCurrency;
                    $rootScope.currencyConversion.storeCurrency = data.storeCurrency;
                    $rootScope.currencyConversion.localCurrency = data.localCurrency;
                    checkAutoCurrencyConversion();
                }
            }
        }
        initializeCurrencyConversion();

        function refreshCurrencyConversion(timeout) {
            $rootScope.currencyConversion.localCurrency &&
                $timeout(function () {
                    convertCurrencies(
                        $rootScope.currencyConversion.displayCurrency ==
                            $rootScope.currencyConversion.storeCurrency
                            ? $rootScope.currencyConversion.localCurrency
                            : $rootScope.currencyConversion.storeCurrency,
                        $rootScope.currencyConversion.displayCurrency
                    );
                }, timeout || 0);
        }
    },
]);
